import React, { useEffect, useState } from "react";
import api from "@/lib/api";

const DEFAULT_PHONE = "+351 912 379 799";

/** Floating WhatsApp chat button (bottom-left). Number comes from the
 *  admin-editable landing content, falling back to the default. */
export default function WhatsAppButton() {
  const [phone, setPhone] = useState(DEFAULT_PHONE);

  useEffect(() => {
    api.get("/content/landing").then((r) => r.data?.phone && setPhone(r.data.phone)).catch(() => {});
  }, []);

  const number = phone.replace(/[^\d]/g, "");
  const msg = encodeURIComponent("Olá GoDrive TVDE! I have a question about TVDE training.");

  return (
    <a
      href={`https://wa.me/${number}?text=${msg}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Chat with us on WhatsApp"
      data-testid="whatsapp-button"
      className="fixed bottom-5 left-5 z-50 w-14 h-14 rounded-full bg-[#25D366] shadow-lg flex items-center justify-center hover:scale-110 transition-transform"
    >
      <svg viewBox="0 0 32 32" className="w-8 h-8 fill-white" aria-hidden="true">
        <path d="M16.004 3C8.832 3 3 8.83 3 16c0 2.29.6 4.53 1.74 6.5L3 29l6.66-1.72A12.94 12.94 0 0 0 16 29c7.17 0 13-5.83 13-13S23.17 3 16.004 3zm0 23.6c-2.08 0-4.12-.56-5.9-1.62l-.42-.25-3.95 1.02 1.05-3.86-.27-.4A10.55 10.55 0 0 1 5.4 16c0-5.85 4.76-10.6 10.6-10.6 5.85 0 10.6 4.75 10.6 10.6s-4.75 10.6-10.6 10.6zm5.82-7.94c-.32-.16-1.89-.93-2.18-1.04-.29-.1-.5-.16-.72.16-.21.32-.82 1.04-1 1.25-.19.21-.37.24-.69.08-.32-.16-1.35-.5-2.57-1.58-.95-.85-1.59-1.9-1.78-2.22-.18-.32-.02-.49.14-.65.15-.14.32-.37.48-.56.16-.19.21-.32.32-.53.1-.21.05-.4-.03-.56-.08-.16-.72-1.73-.98-2.37-.26-.62-.52-.54-.72-.55h-.61c-.21 0-.56.08-.85.4-.29.32-1.12 1.09-1.12 2.66s1.15 3.09 1.31 3.3c.16.21 2.25 3.44 5.46 4.82.76.33 1.36.53 1.82.67.77.25 1.47.21 2.02.13.61-.09 1.89-.77 2.15-1.52.27-.75.27-1.38.19-1.52-.08-.13-.29-.21-.61-.37z"/>
      </svg>
    </a>
  );
}
